import script from "./GeneralGroupsListComponentForJob.vue?vue&type=script&setup=true&lang=js"
export * from "./GeneralGroupsListComponentForJob.vue?vue&type=script&setup=true&lang=js"

import "./GeneralGroupsListComponentForJob.vue?vue&type=style&index=0&id=39068d15&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-39068d15"]])

export default __exports__